import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Switch } from './ui/switch';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MarketingPreferences = () => {
  const [prefs, setPrefs] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const load = () => axios.get(`${API}/marketing/preferences`, { withCredentials: true }).then(r => { setPrefs(r.data); setError(false); }).catch(() => setError(true));
  useEffect(() => { load(); }, []);
  const change = async (key, value) => {
    setBusy(true);
    try { setPrefs((await axios.put(`${API}/marketing/preferences`, { [key]: value }, { withCredentials: true })).data); toast.success('Préférences enregistrées'); }
    catch { toast.error('Impossible d’enregistrer vos préférences.'); }
    finally { setBusy(false); }
  };
  return <section className="py-6 mb-6 border-y border-white/10" data-testid="marketing-preferences">
    <h2 className="text-base font-bold text-white" data-testid="marketing-preferences-title">Les rendez-vous Maya+</h2>
    <p className="text-sm text-white/60 mt-2 mb-4" data-testid="marketing-preferences-info">Recevoir les découvertes, conseils et questionnaires Maya+, le lundi et le jeudi.</p>
    {error ? <p className="text-red-300 text-sm" role="alert" data-testid="marketing-preferences-error">Préférences indisponibles. <button type="button" data-testid="marketing-preferences-retry" onClick={load} className="underline">Réessayer</button></p> : !prefs ? <p data-testid="marketing-preferences-loading" className="text-white/60 text-sm">Chargement…</p> : ['email', 'push'].map(key => <div key={key} className="flex items-center justify-between gap-4 py-3">
      <label className="text-white text-sm" htmlFor={`marketing-pref-${key}`}>{key === 'email' ? 'J’accepte de recevoir les newsletters par email' : 'J’accepte les notifications de découverte sur mon mobile'}</label>
      <Switch id={`marketing-pref-${key}`} data-testid={`marketing-preference-${key}`} checked={prefs[key]} disabled={busy} onCheckedChange={v => change(key, v)} />
    </div>)}
  </section>;
};